var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeLatest } from "redux-saga/effects";
import logger from "../../logger";
import { showAlert } from "../../utils/alert/alert.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getGetDetailSaga } from "../generic/detail.saga";
import { getGetPagedSaga } from "../generic/paged.saga";
import * as subscriptionActions from "../subscription/subscription.actions";
import * as invoiceActions from "./invoice.actions";
import * as invoiceApi from "./invoice.api";
import CONFIG from "./invoice.config";
function markInvoicePaidStartFlow(action) {
    var payload, invoiceId, subscriptionId, invoice, unknownError_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                invoiceId = payload.invoiceId, subscriptionId = payload.subscriptionId;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, , 9]);
                return [4 /*yield*/, call(invoiceApi.markInvoicePaid, invoiceId, { paidAt: new Date() })];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(invoiceApi.getDetail, {
                        id: invoiceId,
                    })];
            case 3:
                invoice = (_a.sent()).data;
                return [4 /*yield*/, put(invoiceActions.markInvoicePaid.actions.success({
                        invoiceId: invoiceId,
                        invoice: invoice,
                    }))];
            case 4:
                _a.sent();
                showAlert({
                    type: "success",
                    message: getLocalizedText("invoices.marked_paid.toast.heading"),
                });
                if (!subscriptionId) return [3 /*break*/, 6];
                return [4 /*yield*/, put(subscriptionActions.getSubscription.actions.start({ subscriptionId: subscriptionId }))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 9];
            case 7:
                unknownError_1 = _a.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(invoiceActions.markInvoicePaid.actions.failure({ invoiceId: invoiceId, error: error }))];
            case 8:
                _a.sent();
                showAlert({
                    type: "error",
                    message: getLocalizedText("invoices.marked_paid.error.toast.heading"),
                });
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function markInvoiceUnpaidStartFlow(action) {
    var payload, invoiceId, invoice, unknownError_2, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                invoiceId = payload.invoiceId;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(invoiceApi.markInvoiceUnpaid, invoiceId)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(invoiceApi.getDetail, {
                        id: invoiceId,
                    })];
            case 3:
                invoice = (_a.sent()).data;
                return [4 /*yield*/, put(invoiceActions.markInvoiceUnpaid.actions.success({ invoiceId: invoiceId, invoice: invoice }))];
            case 4:
                _a.sent();
                showAlert({
                    type: "success",
                    message: getLocalizedText("invoices.marked_unpaid.toast.heading"),
                });
                return [3 /*break*/, 7];
            case 5:
                unknownError_2 = _a.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [4 /*yield*/, put(invoiceActions.markInvoicePaid.actions.failure({ invoiceId: invoiceId, error: error }))];
            case 6:
                _a.sent();
                showAlert({
                    type: "error",
                    message: getLocalizedText("invoices.marked_unpaid.error.toast.heading"),
                });
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(invoiceActions.getDetail.types.START, getGetDetailSaga({
                    entityName: CONFIG.ENTITY_NAME,
                    getDetail: invoiceApi.getDetail,
                }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(invoiceActions.getPaged.types.START, getGetPagedSaga({
                        entityName: CONFIG.ENTITY_NAME,
                        getPaged: invoiceApi.getPaged,
                    }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(invoiceActions.markInvoicePaid.types.START, markInvoicePaidStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(invoiceActions.markInvoiceUnpaid.types.START, markInvoiceUnpaidStartFlow)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line import/no-default-export
export default saga;
